'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (n) {
    return n > 0 ? '+' + n : n.toString();
};